import { apiClient } from "../axiosConfig";
import { typeOrdersFilters } from "./reducer";
import { typeRequestPagination } from "../system/constants";

export type typeOrdersRequestFilters = {
  filters: {
    number?: null | string | number;
    externalNumber?: string | null;
    dateFilter?:
      | {
          endDate: string;
          startDate: string;
        }
      | {};
  };
  pageFilter?: typeRequestPagination;
};

export const getOrdersList = async (payload: {
  filters: typeOrdersFilters;
  paginationRequest: typeRequestPagination;
}) => {
  const path = "/product/archive/order/search";
  const config = {
    headers: {},
  };

  const data: typeOrdersRequestFilters = {
    filters: {},
    pageFilter: payload.paginationRequest,
  };

  const dateCreated = payload.filters.dateCreated;
  if (dateCreated) {
    data.filters.dateFilter = {
      endDate: dateCreated.to || null,
      startDate: dateCreated.from || null,
    };
  }

  if (payload.filters.externalId) {
    data.filters.externalNumber = payload.filters.externalId;
  }

   if (payload.filters.number) {
    data.filters.number = payload.filters.number;
  }

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    if (error.response) {
      console.log(error);
      return error.response;
    } else if (error.request) {
      console.log(error);
      return error.request;
    } else {
      console.log(error);
      return error;
    }
  }
};

export const getSaleByOrderId = async (orderId: string) => {
  const path = `/product/archive/sale/by-order-id?orderId=${orderId}`;

  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
